(function () {
  const STORAGE_KEY = 'cartRewardsUnlockedCount';

  function refreshStaleRewards() {
    const current = document.querySelector('.cart-rewards');
    if (!current) return;

    const cartUrl = (window.routes && window.routes.cart_url) || '/cart';
    fetch(`${cartUrl}?sections=cart-drawer`, { headers: { Accept: 'application/json' } })
      .then((response) => (response.ok ? response.json() : null))
      .then((data) => {
        const html = data && data['cart-drawer'];
        if (!html) return;

        const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('.cart-rewards');
        if (!fresh) return;

        const currentRail = current.querySelector('.cart-rewards__rail');
        const freshRail = fresh.querySelector('.cart-rewards__rail');
        const isStale =
          current.dataset.unlockedCount !== fresh.dataset.unlockedCount ||
          (currentRail && freshRail && currentRail.dataset.fill !== freshRail.dataset.fill);

        if (isStale) current.replaceWith(fresh);
      })
      .catch(() => {});
  }

  function checkRewards(node) {
    const rewards = node.matches && node.matches('.cart-rewards') ? node : node.querySelector && node.querySelector('.cart-rewards');
    if (!rewards) return;

    const unlockedCount = parseInt(rewards.dataset.unlockedCount || '0', 10);
    const previous = sessionStorage.getItem(STORAGE_KEY);

    if (previous !== null && unlockedCount > parseInt(previous, 10)) {
      const panel = document.querySelector('cart-drawer .drawer__inner') || document.querySelector('cart-drawer');
      if (panel && window.CartConfetti) window.CartConfetti.burst(panel);
    }

    sessionStorage.setItem(STORAGE_KEY, String(unlockedCount));
  }

  function enforceCartRewards(cartData) {
    const rewardsEl = document.querySelector('.cart-rewards');
    if (!rewardsEl) return;

    const t2 = parseInt(rewardsEl.dataset.tier2Threshold || '0', 10);
    const t3 = parseInt(rewardsEl.dataset.tier3Threshold || '0', 10);
    const code = rewardsEl.dataset.tier2Code;
    const items = (cartData && cartData.items) || [];
    const subtotal = (cartData && cartData.items_subtotal_price) || 0;

    // Tier 3 guard: strip the free box when the cart drops below its threshold
    if (t3) {
      const freeBoxIndex = items.findIndex((item) => item.properties && item.properties['_free-box']);
      if (freeBoxIndex > -1 && subtotal < t3) {
        const cartChangeUrl = (window.routes && window.routes.cart_change_url) || '/cart/change';
        fetch(cartChangeUrl + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            line: freeBoxIndex + 1,
            quantity: 0,
            sections: ['cart-drawer', 'cart-icon-bubble'],
            sections_url: window.location.pathname,
          }),
        })
          .then((response) => (response.ok ? response.json() : null))
          .then((parsedState) => {
            const drawer = document.querySelector('cart-drawer');
            if (drawer && parsedState && parsedState.sections) drawer.renderContents(parsedState);
          })
          .catch(() => {});
        return;
      }
    }

    // Tier 3 supersedes tier 2: strip the tier-2 discount once the free-box threshold is reached
    if (t3 && code && subtotal >= t3) {
      const discountApps = (cartData && cartData.cart_level_discount_applications) || [];
      const hasOurDiscount = discountApps.some((d) => (d.title || '').toLowerCase().includes(code.toLowerCase()));
      if (hasOurDiscount) {
        const cartUpdateUrl = (window.routes && window.routes.cart_update_url) || '/cart/update';
        fetch(cartUpdateUrl + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            discount: '',
            sections: ['cart-drawer', 'cart-icon-bubble'],
            sections_url: window.location.pathname,
          }),
        })
          .then((response) => (response.ok ? response.json() : null))
          .then((parsedState) => {
            const drawer = document.querySelector('cart-drawer');
            if (drawer && parsedState && parsedState.sections) drawer.renderContents(parsedState);
          })
          .catch(() => {});
        return;
      }
    }

    // Tier 2: auto-apply the discount code once its threshold is met, but not once tier 3 has taken over
    if (code && t2 && subtotal >= t2 && (!t3 || subtotal < t3)) {
      const hasDiscount = ((cartData && cartData.cart_level_discount_applications) || []).length > 0;
      if (!hasDiscount) {
        fetch('/discount/' + encodeURIComponent(code))
          .then((response) => {
            if (!response.ok) return null;
            const cartUrl = (window.routes && window.routes.cart_url) || '/cart';
            return fetch(`${cartUrl}.js?sections=cart-drawer,cart-icon-bubble`, {
              headers: { Accept: 'application/json' },
            }).then((r) => (r.ok ? r.json() : null));
          })
          .then((parsedState) => {
            const drawer = document.querySelector('cart-drawer');
            if (drawer && parsedState && parsedState.sections) drawer.renderContents(parsedState);
          })
          .catch(() => {});
      }
    }
  }

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach(checkRewards);
    });
  });

  if (document.querySelector('.cart-rewards')) {
    checkRewards(document.querySelector('.cart-rewards'));
  }

  observer.observe(document.body, { childList: true, subtree: true });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      enforceCartRewards(event.cartData);
      setTimeout(refreshStaleRewards, 700);
    });
  }
})();
